import React, { useState } from "react";
import "./header.css";
import { useNavigate } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
import Button from "@mui/material/Button";

function Header() {
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        setExpanded(!expanded);
    };
    const navigate = useNavigate();

    return (
        <Navbar
            collapseOnSelect
            expand="lg"
            className="header"
            expanded={expanded}
        >
            <div className="container">
                <Navbar.Brand
                    onClick={() => {
                        navigate("/");
                    }}
                >
                    <span className="navbar-brand-text hover:text-white">
                        Humanizer
                    </span>
                </Navbar.Brand>
                <Navbar.Toggle
                    aria-controls="responsive-navbar-nav"
                    onClick={handleToggle}
                />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="ml-auto nav">
                        <Button
                            className="NavDropDown_Button"
                            onClick={() => navigate("/aichecker")}
                        >
                            <Nav.Link
                                id="nav-dropdown-dark-example"
                                title="Ai Checker"
                                menuVariant="light"
                            >
                                Ai-Detect
                            </Nav.Link>
                        </Button>
                        <Button
                            className="NavDropDown_Button"
                            onClick={() => navigate("/summarize")}
                        >
                            <Nav.Link
                                id="nav-dropdown-dark-example"
                                title="Humanizer"
                                menuVariant="light"
                            >
                                Summarize
                            </Nav.Link>
                        </Button>
                        <Button
                            className="NavDropDown_Button"
                            onClick={() => navigate("/optimize")}
                        >
                            <Nav.Link
                                id="nav-dropdown-dark-example"
                                title="Plagiarism"
                                menuVariant="light"
                            >
                                Optimize
                            </Nav.Link>
                        </Button>
                        <Button
                            className="NavDropDown_Button"
                            onClick={() => navigate("/humanize")}
                        >
                            <Nav.Link
                                id="nav-dropdown-dark-example"
                                title="Translator"
                                menuVariant="light"
                            >
                                Humanize
                            </Nav.Link>
                        </Button>
                    </Nav>
                </Navbar.Collapse>
            </div>
        </Navbar>
    );
}

export default Header;
